import React, { useState, useRef } from 'react'

// Deps
// import { connect } from 'react-redux'

// Functions
import formatNumber from 'functions/format-number'
import stringToFloat from 'functions/string-to-float'

// Partials
import Btn from 'views/shared/partials/btn'
import Pricebox from 'views/shared/partials/pricebox'
import { InputForm, FormInput } from 'views/shared/partials/forms'
import ConversionInfo from 'views/shared/partials/conversion-info'

// Services
import orderServices from 'services/order'

// Data
import currencyTypes from 'data/currency-types'

const getPaymentAmount = (payment) => {
	let paymentPrice = payment.price;

	if(payment.currency_exchange_total) {
		return parseFloat((((payment.currency_exchange_total - (payment.currency_exchange_refund_total ? payment.currency_exchange_refund_total : 0)) / payment.real_price) * paymentPrice).toFixed(2));
	}
	else {
		return parseFloat((paymentPrice - parseFloat(payment.refund_total)).toFixed(2));
	}
}

const useFloatRefundTotal = (refundTotal, payment) => {
	let refundPrice = stringToFloat(refundTotal);

	
	let paymentPrice = payment.price;
	let realPrice = payment.real_price;
	let exchangeRate = payment.currency_exchange_rate ? payment.currency_exchange_rate.currency_exchange_rate : 0;
	
	let refundRealPrice = (refundPrice * realPrice) / paymentPrice;
	let exchangePrice = refundPrice/ exchangeRate;
	let exchangeRealPrice = refundRealPrice / exchangeRate;

	return [refundPrice, refundRealPrice, exchangePrice, exchangeRealPrice - exchangePrice]; 
}

const RefundPaymentModal = (props) => {
	// const payment = props.payment;
	const close = props.close;

	const payment = useRef({
		...props.payment,
		real_price: parseFloat(props.payment.real_price),
		price: parseFloat(props.payment.price),
		currency_exchange_total: ((props.payment.currency_exchange_total && props.payment.currency_exchange_total !== '0') ? parseFloat(props.payment.currency_exchange_total) : false),
		currency_exchange_rate: props.payment.currency_exchange_rate ? {...props.payment.currency_exchange_rate, currency_exchange_rate: parseFloat(props.payment.currency_exchange_rate.currency_exchange_rate)} : false,
		currency_exchange_refund_total: props.payment.currency_exchange_refund_total ? props.payment.currency_exchange_refund_total : false,
		refund_total: parseFloat(props.payment.refund_total),
		refund_real_total: parseFloat(props.payment.refund_real_total),
		refundable: !(props.payment.payment_type && props.payment.payment_type.payment_code === 'nakit'),
	});
	
	const maxNum = useRef(getPaymentAmount(payment.current));
	const paymentCurrency = useRef(payment.current.currency_exchange_total ? currencyTypes[0] : currencyTypes.find((type) => (type.id === payment.current.order.price_type.id.toString())));

	const [submitting, setSubmitting] = useState(false);
	const [refundTotal, setRefundTotal] = useState(formatNumber(maxNum.current));
	// const [refundCurrency, setRefundCurrency] = useState(currencyTypes.find((currency) => (currency.id === payment.order.price_type.id.toString())))

	const [refundTotalNum, refundRealPrice, exchangePrice, exchangeRealPrice] = useFloatRefundTotal(refundTotal, payment.current);

	const submit = (formData) => {
		setSubmitting(true);

		orderServices.refundPayment({
			refund_reason: formData.refund_reason,
			refund_price: formData.price,
			order_business_code: payment.current.order.business_order_code,
			payment_id: payment.current.id,
			add_ratio: 1
		}).then((payload) => {
		props.onSuccess();
		close();
		}).catch(() => {}).finally(() => {
			setSubmitting(false);
		})
	}

	return (
		<InputForm
			ignoreEmpty
			onSubmit={submit}
			className={props.className}>
			<div className="modal-header dark">
				<h1 className="header-title">Ödeme İadesi</h1>
				{props.closeBtn}
			</div>

			<div className="modal-content">
				{(payment.current.refundable) ?
					<div className="grid-container">
						<div className="row">
							<div className="col x10 m-x9">
								<FormInput
									className="refund-total"
									innerContent={<span className="total-currency">{paymentCurrency.current.symbol}</span>}
									disabled={submitting}
									type="number"
									label="İade Tutarı"
									mask="number"
									value={refundTotal}
									onChange={setRefundTotal}
									validation={{
										required: "İade tutarını girmelisiniz",
										maxNum: ['İade tutarı ödeme tutarından fazla olamaz.', maxNum.current, true],
									}}
									hideAsterisk
									decimals={2}
									name="price" />
							</div>
							{refundTotalNum !== maxNum.current &&
								<div className="col x2 m-x3">
									<Btn
										block big gray outline
										className="big-icon"
										onClick={() => {
											setRefundTotal(formatNumber(maxNum.current));
										}}
										icon="refresh" />
								</div>
							}
						</div>
						<div className="row">
							<div className="col">
								{payment.current.real_price !== payment.current.price &&
									<p className="refund-inforow">
										<label className="label dark">Vade Farkı Dahil Tutar:</label> <Pricebox price={refundRealPrice} currency={paymentCurrency.current.symbol} />
									</p>
								}
								<p className="refund-inforow">
									<label className="label dark">{payment.current.installment_count} Taksit</label> {/*<span className="text-yellow-dark">%{formatNumber(payment.current.real_price / payment.current.price)}</span> Vade*/}
								</p>
							</div>
						</div>
						{payment.current.currency_exchange_total &&
							<div className="row">
								<div className="col">
									<p className="refund-inforow">
										<label className="label dark">Döviz Karşılığı:</label> <Pricebox price={exchangePrice} currency={payment.current.order.price_type.currency_symbol} /> + <label className="label small"><Pricebox monochrome price={exchangeRealPrice} currency={payment.current.order.price_type.currency_symbol} /></label>
									</p>
									<p className="refund-inforow">
										<ConversionInfo
											dark
											exchangeType={payment.current.currency_exchange_rate.currency_exchange_type_id}
											currency={payment.current.order.price_type.currency_symbol}
											price={payment.current.currency_exchange_rate.currency_exchange_rate} />
									</p>
								</div>
							</div>
						}
						<div className="row">
							<div className="col">
								<FormInput
									type="textarea"
									disabled={submitting}
									label="İade Sebebi"
									rows="2"
									name="refund_reason"
									validation={{
										required: 'Bir iade sebebi girmelisiniz.'
									}} />
							</div>
						</div>
					</div>
					:
					<div className="alert center warning"><div className="alert-content">
						Nakit ödemeleri iptal edemezsiniz.
					</div></div>
				}
			</div>

			<div className="modal-controls">
				{payment.current.refundable ?
					<React.Fragment>
						<Btn
							nude
							disabled={submitting}
							onClick={close}>
							Vazgeç
						</Btn>
						<Btn
							loading={submitting}
							disabled={submitting}
							type="submit">
							İade Yap
						</Btn>
					</React.Fragment>
					:
					<Btn
						onClick={close}>
						Tamam
					</Btn>
				}
			</div>
		</InputForm>
	)
}

RefundPaymentModal.defaultProps = {
	className: '',
	containerClass: 'modal-refund-payment',
	name: 'refund-payment',
	payment: false,
}

export default RefundPaymentModal